module.exports = __webpack_public_path__ + "media/บูมชิคกะบูม.b04f7602.mp3";